import React from 'react';
import { Button } from '..';
import { getInitial } from '../../utils';

import './styles.css';
import icPlay from '../../assets/ic-play.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { authPopup } from '../../redux/actions/auth';

const ContentDetail = ({ item, handleClickDetail, checkBlockUnblock }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { token } = useSelector((state) => state.auth);

  const handleClickWatch = async () => {
    if (item.premium && !token) {
      return dispatch(authPopup.show());
    }

    if (item.type === 'clips') {
      if (token && checkBlockUnblock) {
        const res = await checkBlockUnblock(item);
        if (res) return;
      }

      history.push(`clips/${item.id}`);
    }
  };

  return (
    <>
      <div className='item-detail'>
        <div className='content-details'>
          <div className='content-genres'>
            {item?.tags?.genres?.map((genre) => {
              return <div key={genre}>{genre}</div>;
            })}
          </div>
        </div>
        <div className='title' onClick={handleClickDetail}>
          {item.titleLocalized}
        </div>
        <span className='profile'>
          {item?.profile?.avatar ? (
            <img src={item.profile.avatar} alt='avatar' className='avatar' />
          ) : (
            <div className='avatar'>{getInitial(item.profile.name)}</div>
          )}
          <span style={{ color: '#FFFFFF' }}>{item?.profile?.name}</span>
        </span>
        <div className='content-actions'>
          <Button
            icon={icPlay}
            iconStyle={{
              width: 40,
              height: 40,
              backgroundColor: '#F49832',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
            }}
            //textColor='primary'
            // type='text'
            shape='rounded'
            fontSize={16}
            size='large'
            width={224}
            style={{
              height: '40px',
            }}
            onClick={handleClickWatch}
          >
            Watch Now
          </Button>
        </div>
      </div>
    </>
  );
};

export default ContentDetail;
